import { faChevronRight } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import "./navigationView.scss";

interface INavigationViewOption {
  title: string;
  index: number;
}

interface INavigationViewProps {
  subViewOptions: INavigationViewOption[];
  setViewIndex: (index: number) => void;
}

export function NavigationView(props: INavigationViewProps) {
  const { subViewOptions, setViewIndex } = props;

  return (
    <div className="website-builder-navigation-view-options">
      {subViewOptions.map(subViewOption => (
        <div
          key={subViewOption.index}
          className="navigation-view-option"
          onClick={() => setViewIndex(subViewOption.index)}
        >
          <div className="navigation-view-option-title">{subViewOption.title}</div>
          <FontAwesomeIcon className="navigation-view-option-chevron" icon={faChevronRight} />
        </div>
      ))}
    </div>
  );
}
